// extracted by mini-css-extract-plugin
export default {"footerBg":"Ea-z","footerTopLinks":"Fa-z","footerFeedback":"Ga-z","footerSocial":"Ha-z","footerLegalLinks":"Ia-z","footerIconCards":"Ja-z","footerBotCopy":"Ka-z"};